"use client";

import CaretDownIcon from "public/next-public/common/icons/caret-regular-down.svg";

import styles from "./questions.module.scss";

/** The shared "Show More / Show Less" control. Always a button: a link would change the URL. */
export default function ShowMoreToggle({
  expanded,
  moreLabel,
  lessLabel,
  controls,
  onToggle,
  ...dataAttributes
}: ShowMoreToggleProps) {
  return (
    <button
      {...dataAttributes}
      type="button"
      className={styles.showMoreToggle}
      aria-expanded={expanded}
      aria-controls={controls}
      onClick={onToggle}
    >
      {expanded ? lessLabel : moreLabel}
      <CaretDownIcon
        className={`${styles.showMoreCaret} ${expanded ? styles.showMoreCaretExpanded : ""}`}
        width={16}
        height={16}
        aria-hidden
      />
    </button>
  );
}

interface ShowMoreToggleProps {
  expanded: boolean;
  moreLabel: string;
  lessLabel: string;
  /** Id of the region the toggle reveals, so screen readers follow the relationship. */
  controls?: string;
  onToggle: () => void;
  /** `data-*` attributes land on the rendered element, e.g. stable hooks for session-replay tools. */
  [dataAttribute: `data-${string}`]: string | number | boolean | undefined;
}
